import clsx from "clsx";
import getPlayerContent from "@/domains/chat/helpers/getPlayerContent";
import getPlayerTitleContent from "@/domains/chat/helpers/getPlayerTitleContent";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";
import { TypePaintingMessage } from "@/domains/settings/chat/constants/chat";

export default function ChatStaffMessage({ message, settings }: MessageProps) {
  const { showTime, messageHeader, typePaintingMessage } = settings;

  return (
    <div className={clsx("overflow-clip w-full text-[#e1cf1c]")}>
      <div className={clsx({ inline: !messageHeader })}>
        {showTime && <Time date={message.date} />}{" "}
        <span>
          {getPlayerTitleContent(message)}
          {getPlayerContent(message)}
        </span>
        {": "}
      </div>
      <div
        className={clsx("font-medium", {
          "text-white": typePaintingMessage !== TypePaintingMessage.Classic,
          inline: !messageHeader,
        })}
      >
        {message.message.content}
      </div>
    </div>
  );
}
